import * as types from '../config/actionTypes';

const UserActions = {
	readData: (data) => ({ type: types.READ_USER, data }),
	createData: (data) => ({ type: types.CREATE_USER, data }),
	updateData: (data) => ({ type: types.UPDATE_USER, data }),
	deleteData: (data) => ({ type: types.DELETE_USER, data }),
	requestOtp: (data) => ({ type: types.REQUEST_OTP, data }),
	otpActivated: (data) => ({ type: types.SUCCESS_OTP, data }),
	otpDeactivated: (data) => ({ type: types.REVOKE_OTP, data })
};

export default UserActions;
